export class ZonesAreasUtilies {
  public static readonly ZONE_POLYGON_COLOR = '#0883c7';
  public static readonly AREA_POLYGON_COLOR = '#F87C56';
}
